import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import TableWidget from "../../../components/tables/TableWidget";
import {
  getSearchInvoicesTableData,
  searchInvoicesTableHeader,
} from "./components/tableConfigs/searchInvoicesTableConfig";
import { fetchSearchInvoice } from "../../../redux/api/raports.api";

import SearchInvoicesActionButton from "./components/TableActionsButtonsComponents/SearchInvoicesActionButton";
import ContentCard from "../../../components/misc/ContentCard";
import TextInput from "../../../components/misc/TextInput";
import CustomButton from "../../../components/CustomButton";
import { useState } from "react";

function SearchInvoices() {
  const dispatch = useAppDispatch();

  const {
    raports: {
      searchInvoice: {
        data: searchInvoiceData,
        isLoading: isLoadingSearchInvoice,
      },
    },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const [nrFactura, setNrFactura] = useState<string | number | null>(null);

  const handleSearchByNrFactura = () => {
    if (nrFactura) {
      dispatch(
        fetchSearchInvoice({
          factura: nrFactura,
        }),
      );
    }
  };

  return (
    <>
      <ContentCard cardTitle="Cauta expeditie dupa factura">
        <div className="flex items-center gap-2">
          <TextInput
            type="text"
            label="Introduceti nr. facturii"
            name="factura"
            value={nrFactura}
            onChange={(value) => setNrFactura(value)}
            withVerticalSpacer
            withUpperCasing
          />

          <CustomButton
            variant="contained"
            style={{ height: 50, width: 100, marginLeft: 10 }}
            loading={isLoadingSearchInvoice}
            disabled={isLoadingSearchInvoice}
            onClick={handleSearchByNrFactura}>
            Cauta
          </CustomButton>
        </div>
      </ContentCard>

      {searchInvoiceData.length > 0 && (
        <TableWidget
          tableHeaderData={searchInvoicesTableHeader}
          tableItemsData={getSearchInvoicesTableData(searchInvoiceData)}
          tableLoading={isLoadingSearchInvoice}
          ActionButtonsComponent={(props: any) => (
            <SearchInvoicesActionButton {...props} />
          )}
          withTablePagination={false}
          borderedRow
        />
      )}
    </>
  );
}

export default SearchInvoices;
